import { useEffect, useRef, useState } from 'react';
import { useSearchParamsUpdater } from 'hooks/useSearchParamsUpdater';
import SessionStorageUtils from 'utils/SessionStorageUtils';
import { isValidDateString } from 'helpers/isValidDateString';
import { formatKyivDate } from 'helpers/formatKyivDate';
import { SessionStorageKeys } from 'constants/sessionStorageKeys';

export const useSyncedDate = (isSetupQuery) => {
  const [currentDate, setCurrentDate] = useState();
  const query = useSearchParamsUpdater();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (!isSetupQuery) return;

    const urlDate = query.getParam('date');
    const savedDate = SessionStorageUtils.getData(SessionStorageKeys.SCHEDULE_DATE);
    const today = formatKyivDate(new Date());

    const finalDate = isValidDateString(urlDate) ? urlDate : isValidDateString(savedDate) ? savedDate : today;

    setCurrentDate(finalDate);
    SessionStorageUtils.setData(SessionStorageKeys.SCHEDULE_DATE, finalDate);

    if (!isValidDateString(urlDate)) {
      query.setParam('date', finalDate);
    }

    isFirstRender.current = false;
  }, [isSetupQuery]);

  useEffect(() => {
    if (isFirstRender.current || !currentDate) return;

    const urlDate = query.getParam('date');

    if (urlDate !== currentDate) {
      query.setParam('date', currentDate);
    }

    SessionStorageUtils.setData(SessionStorageKeys.SCHEDULE_DATE, currentDate);
  }, [currentDate]);

  return [currentDate, setCurrentDate];
};
